export default "__VITE_ASSET__764032fe__"